import { graphql } from "babel-plugin-relay/macro";
import { useCallback, useContext } from "react";
import { useMutation } from "react-relay";
import {
  useAppClipNotificationsUpdateMutation$variables,
  useAppClipNotificationsUpdateMutation as useAppClipNotificationsUpdateMutationType,
} from "./__generated__/useAppClipNotificationsUpdateMutation.graphql";
import SnackbarContext from "../contexts/SnackbarContext";

const mutation = graphql`
  mutation useAppClipNotificationsUpdateMutation(
    $appConfigId: ID!
    $notifications: [GraphQLAutomatedNotificationInput!]!
  ) {
    updateAppClipAutomatedNotifications(
      appConfigId: $appConfigId
      notifications: $notifications
    ) {
      ... on BrandType {
        appConfig {
          id
          appClipAutomatedNotifications {
            edges {
              node {
                id
                notifType
                title
                message
                isEnabled
                delaySeconds
                landingPath
              }
            }
          }
        }
      }
    }
  }
`;

const useAppClipNotificationsUpdateMutation = (): [
  (
    vars: useAppClipNotificationsUpdateMutation$variables,
    onCompleted?: () => void
  ) => void,
  boolean
] => {
  const [saveMutation, isMutationInFlight] =
    useMutation<useAppClipNotificationsUpdateMutationType>(mutation);
  const snackbarContext = useContext(SnackbarContext);

  const onMutate = useCallback(
    (
      vars: useAppClipNotificationsUpdateMutation$variables,
      onCompleted?: () => void
    ) => {
      saveMutation({
        variables: vars,
        onCompleted: (data, errors) => {
          if (errors) {
            snackbarContext?.openSnackbar("Update Failed", "error");
          } else {
            onCompleted && onCompleted();
            snackbarContext?.openSnackbar("Update Successful", "success");
          }
        },
        onError: (error: Error) => {
          snackbarContext?.openSnackbar("Update Failed", "error");
        },
      });
    },
    [snackbarContext, saveMutation]
  );

  return [onMutate, isMutationInFlight];
};

export default useAppClipNotificationsUpdateMutation;
